import { useSelector } from 'react-redux';

import { ICartState } from 'pages/Cart/redux/reducer';
import { ILoyaltyPointState } from '../redux/LoyaltyPoints.reducer';
import CHECKOUT_CONSTANT from 'pages/Checkout/constants/checkout.constant';
import { isExisty } from 'utils/helpers.util';

const useLoyaltyThresholdReached = () => {
  const { loyaltyVouchers, cartTotalAmount, totalPointsValue } = useSelector(
    (state: { loyalty: ILoyaltyPointState; cart: ICartState }) => {
      const {
        cart: {
          cartData: { loyaltyVouchers: vouchers, totalPrice: { value: cartTotal = 0 } = {} },
        },
        loyalty: { totalPointsValue: points },
      } = state;

      return {
        loyaltyVouchers: vouchers,
        cartTotalAmount: cartTotal,
        totalPointsValue: points,
      };
    }
  );

  const isVoucherExists = isExisty(loyaltyVouchers) ? !!loyaltyVouchers[0] : null;
  const { loyaltyPointsThreshold } = CHECKOUT_CONSTANT;

  const isThresholdReached = isVoucherExists
    ? true
    : cartTotalAmount !== 0 &&
      totalPointsValue >= loyaltyPointsThreshold &&
      cartTotalAmount > loyaltyPointsThreshold;

  return isThresholdReached;
};

export default useLoyaltyThresholdReached;
